/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you lock a driver or constructor, fewer combinations need to be checked, and only teams containing your picks are shown.`)
};

const es_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando bloqueas un piloto o constructor, se evalúan menos combinaciones y solo se muestran los equipos con tus selecciones.`)
};

const de_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du einen Fahrer oder Konstrukteur sperrst, werden weniger Kombinationen geprüft und nur Teams mit deinen Auswahlen angezeigt.`)
};

const nl_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je een coureur of constructeur vergrendelt, worden er minder combinaties gecontroleerd en worden alleen teams met jouw keuzes getoond.`)
};

const fr_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand vous verrouillez un pilote ou un constructeur, moins de combinaisons sont vérifiées et seules les équipes contenant vos choix sont affichées.`)
};

const it_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando blocchi un pilota o costruttore, vengono verificate meno combinazioni e vengono mostrati solo i team con le tue selezioni.`)
};

const pt_br2_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você fixa um piloto ou construtor, menos combinações são verificadas e apenas equipes com suas seleções são mostradas.`)
};

const pt_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando fixa um piloto ou construtor, são verificadas menos combinações e apenas equipas com as suas seleções são mostradas.`)
};

const ja_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライバーやコンストラクターをロックすると、確認する組み合わせが減り、あなたの選択を含むチームのみ表示されます。`)
};

const zh_f1_apex_help_locking_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当您锁定某位车手或车队时，需要检查的组合减少，只显示包含您选择的车队。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_help_locking_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_help_locking_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_help_locking_desc", locale)
	if (locale === "en") return en_f1_apex_help_locking_desc(inputs)
	if (locale === "es") return es_f1_apex_help_locking_desc(inputs)
	if (locale === "de") return de_f1_apex_help_locking_desc(inputs)
	if (locale === "nl") return nl_f1_apex_help_locking_desc(inputs)
	if (locale === "fr") return fr_f1_apex_help_locking_desc(inputs)
	if (locale === "it") return it_f1_apex_help_locking_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_help_locking_desc(inputs)
	if (locale === "pt") return pt_f1_apex_help_locking_desc(inputs)
	if (locale === "ja") return ja_f1_apex_help_locking_desc(inputs)
	return zh_f1_apex_help_locking_desc(inputs)
};